import { NavigateFunction } from "react-router-dom";
import { select, takeLatest } from "redux-saga/effects";
import { all } from "redux-saga/effects";
import { efilialActions } from "./reducer";
import { put } from "redux-saga/effects";
import { call } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/mainReducer";
import { apiCall } from "../../utils/apiCall";

const getitens = (state: RootState) => state.inventory.itens;

function* checkPalletWorker({ payload }: PayloadAction<string>) {
  try {
    const itens: Record<string, any>[] = yield select(getitens);
    if (itens.findIndex((item) => item.codigo === payload) !== -1) {
      yield put(
        efilialActions.checkPalletError(`O pallet ${payload} já foi lido`)
      );
      return;
    }

    const res: { data: Record<string, any> } = yield call(apiCall, {
      url: `/apiCargas/pallet/${payload}?inventario=1`,
      method: "GET",
    });

    yield put(efilialActions.checkPalletSuccess(res.data));
  } catch (error: any) {
    yield put(
      efilialActions.checkPalletError(
        `Erro ao verificar pallet online: ${error?.response?.data ? error.response.data.error : JSON.stringify(error)
        }`
      )
    );
  }
}

function* sendInventarioWorker({
  payload,
}: PayloadAction<{
  codigoPallet: string;
  qtd: number;
  navigate: NavigateFunction;
}>) {
  try {
    yield call(apiCall, {
      url: `/apiCargas/filial-entry/${payload.codigoPallet}`,
      method: "POST",
      data: {
        qtd: payload.qtd,
      },
    });
    yield put(
      efilialActions.addInventoryItem({
        codigo: payload.codigoPallet,
        quantidade: payload.qtd,
      })
    );
    yield put(efilialActions.sendInventarioSuccess());
    payload.navigate(`/efilial`);
  } catch (error: any) {
    yield put(
      efilialActions.sendInventarioError(
        `Erro ao salvar estoque de filial: ${error?.response?.data ? error.response.data : JSON.stringify(error)
        }`
      )
    );
  }
}

export function* efilialSaga() {
  yield all([
    takeLatest("efilial/requestCheckPallet", checkPalletWorker),
    takeLatest("efilial/requestSendInventario", sendInventarioWorker),
  ]);
}